import TaskPanel from './TaskPanel';

export default TaskPanel;
